"use client";

import Link from "next/link";
import { type VariantProps } from "class-variance-authority";
import { buttonVariants } from "@/components/ui/button-variants";
import { useLocale } from "@/lib/i18n/locale-context";
import { localizeHref } from "@/lib/i18n/routing";
import { externalAnchorProps } from "@/lib/constants";
import { cn } from "@/lib/utils";

type ButtonLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  external?: boolean;
} & VariantProps<typeof buttonVariants>;

export default function ButtonLink({
  href,
  children,
  className,
  external,
  variant = "default",
  size = "default",
}: ButtonLinkProps) {
  const locale = useLocale();
  const classes = cn(buttonVariants({ variant, size }), className);
  const resolvedHref = external ? href : localizeHref(href, locale);

  if (external) {
    return (
      <a href={href} className={classes} {...externalAnchorProps(href)}>
        {children}
      </a>
    );
  }

  return (
    <Link href={resolvedHref} className={classes}>
      {children}
    </Link>
  );
}
